import React from 'react';
import { Container, Row} from 'reactstrap';
import { subscribe } from 'react-contextual';
import ImageCard from '../../cards/imageCard';
import onClickHandle from '../onClickHandle';

const createImages = (images, panelName) => (
	images.map((image, index) => <ImageCard {...image} key={index} clickHandler={(e) => onClickHandle(e, 'image-panel-click', ({ index, panelName }), image.link)} />)
);

const ImagePanel = ({
	images, panelName, heading
}) => (
	<Container className="panel-padding">
		{typeof heading !== 'undefined' ?
		<Row>
			<h2>{heading}</h2>
		</Row>
		:
		null}
		<Row className="d-flex remove-margin justify-content-center m-image-panel-container">
			{createImages(images, panelName)}
		</Row>
	</Container>
);

ImagePanel.defaultProps = {
	panelName: 'panel',
	className: 'd-flex justify-content-center',
	images: [
		{
			src: {
				mobile: 'https://cdn.givind.org/static/banner1.jpg',
				desktop: 'https://s3.ap-south-1.amazonaws.com/give-marketplace-dev/static/images/wg/ola/BANNER-Ola.jpg',
			},
			alt: 'Banner 1',
			className: 'image-w-58',
			style: {},
			link: 'https://docs.google.com/document/d/1outz6Xq3uIuQIpg9UZsI37oLZK9zK3o-55ZHSxxli1U/edit'
		}
	],
};

export default subscribe()(ImagePanel);
